export enum EmploymentAndBankDetails {
  // employment status id
  haveJob = 1,
  unemployed = 2,
  neverWorked = 3,
}
